import type { ComponentProps } from 'react';

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

export function Collapsible(collapsibleProps: ComponentProps<typeof CollapsiblePrimitive.Root>) {
  const { ...props } = collapsibleProps;
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

export function CollapsibleTrigger(collapsibleTriggerProps: ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) {
  const { ...props } = collapsibleTriggerProps;
  return <CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />;
}

export function CollapsibleContent(collapsibleContentProps: ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  const { ...props } = collapsibleContentProps;
  return <CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />;
}
